import { construct } from 'ramda';

import { SetPeople, LoadPerson, LoadBlock } from './people.actions';

export const setPeople = construct(SetPeople);
export const loadPerson = construct(LoadPerson);
export const loadBlock = construct(LoadBlock);
